import { graphql } from '../__generated__/gql';

export const GENERATE_SIGNED_URL = graphql(/* GraphQL */ `
  mutation GenerateSignedUrl($fileName: String!, $mime: String!, $mediaContext: MediaContext) {
    generateSignedUrl(fileName: $fileName, mime: $mime, mediaContext: $mediaContext) {
      blobLocation
      url
    }
  }
`);

export const CREATE_MEDIA_METADATA = graphql(/* GraphQL */ `
  mutation CreateMediaMetadata($input: MediaMetadataInput!) {
    createMediaMetadata(input: $input) {
      mediaId
      floc
      fileName
    }
  }
`);

export const GET_MEDIA_BY_FLOC = graphql(/* GraphQL */ `
  query MediaMetadataByFloc($floc: String!) {
    mediaMetadataByFloc(floc: $floc) {
      mediaId
      mime
      fileName
      url
      floc
    }
  }
`);
